module.exports = __webpack_public_path__ + "static/media/transport@2x.5d13e2a8.png";